var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationDisconnectedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Disconnect",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#e00f0f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3591",
    "data-name": "Group 3591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M5.74,13.36,4.69,14.41a.773.773,0,0,1-1.09,0H3.59a.785.785,0,0,1,0-1.1l1.05-1.05,1.1,1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3590",
    "data-name": "Group 3590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M5.71,12.29a3.926,3.926,0,0,0,5.09.27L5.44,7.2a3.95,3.95,0,0,0,.27,5.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M12.25,11.49l.36-.36a.827.827,0,0,0,0-1.18l-.48-.48,1.83-1.83a.778.778,0,0,0-1.1-1.1L11.03,8.37,9.57,6.91l1.76-1.76a.778.778,0,0,0-1.1-1.1L8.47,5.81l-.42-.42a.827.827,0,0,0-1.18,0l-.36.36L3.76,3.01a.544.544,0,1,0-.77.77L14.22,15.01a.544.544,0,0,0,.77-.77Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationDisconnectedIcon);
export default __webpack_public_path__ + "static/media/conversation-disconnected-icon.2bc4209c29307f326451f4f1ee577b38.svg";
export { ForwardRef as ReactComponent };